"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from "react";
import type { Message } from "@/types/chat";
import type { AIModel } from "@/lib/apiKeyStorage";
import type { FeatureId } from "@/types/features";
import MessageItem from "./MessageItem";
type MessageListProps = {
  messages: Message[];
  loading: boolean;
  thinking: boolean;
  currentModel?: AIModel;
  onRevertToMessage?: (messageId: string, switchToOriginalModel: boolean) => void;
  onRevertWithDraft?: (messageId: string, switchToOriginalModel: boolean) => void;
  onForkFromMessage?: (messageId: string) => void;
  messageActionsDisabled?: boolean;
  isFeatureEnabled?: (featureId: FeatureId) => boolean;
};
const MessageList: React.FC<MessageListProps> = t0 => {
  const $ = _c(26);
  const {
    messages,
    loading,
    thinking,
    currentModel,
    onRevertToMessage,
    onRevertWithDraft,
    onForkFromMessage,
    messageActionsDisabled: t1,
    isFeatureEnabled
  } = t0;
  const messageActionsDisabled = t1 === undefined ? false : t1;
  const bottomRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!bottomRef.current) {
        return;
      }
      bottomRef.current.scrollIntoView({
        behavior: "smooth"
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== messages.length || $[2] !== thinking) {
    t3 = [messages.length, thinking];
    $[1] = messages.length;
    $[2] = thinking;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== loading) {
    t4 = loading && <div className="text-xs text-foreground/60">Loading messages…</div>;
    $[4] = loading;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentModel || $[7] !== isFeatureEnabled || $[8] !== messageActionsDisabled || $[9] !== messages || $[10] !== onForkFromMessage || $[11] !== onRevertToMessage || $[12] !== onRevertWithDraft) {
    t5 = messages.map((m, index) => <MessageItem key={m.id} message={m} index={index} totalMessages={messages.length} currentModel={currentModel} onRevertToMessage={onRevertToMessage} onRevertWithDraft={onRevertWithDraft} onForkFromMessage={onForkFromMessage} messageActionsDisabled={messageActionsDisabled} nextMessage={messages[index + 1]} isFeatureEnabled={isFeatureEnabled} />);
    $[6] = currentModel;
    $[7] = isFeatureEnabled;
    $[8] = messageActionsDisabled;
    $[9] = messages;
    $[10] = onForkFromMessage;
    $[11] = onRevertToMessage;
    $[12] = onRevertWithDraft;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== thinking) {
    t6 = thinking && <div className="flex w-full justify-start"><div className="max-w-[50%] rounded-lg px-3 py-2 text-sm bg-white/60 text-foreground border border-white/40 shadow-sm backdrop-blur-md"><div className="mb-1 text-[10px] uppercase tracking-wide opacity-70">Assistant</div><div className="flex items-center gap-2 text-xs text-foreground/60"><span className="h-2 w-2 rounded-full bg-sky animate-pulse" /><span className="animate-pulse">Thinking…</span></div></div></div>;
    $[14] = thinking;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== loading || $[17] !== messages.length || $[18] !== thinking) {
    t7 = !loading && messages.length === 0 && !thinking && <div className="text-sm text-foreground">Start the conversation by sending a message.</div>;
    $[16] = loading;
    $[17] = messages.length;
    $[18] = thinking;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div ref={bottomRef} />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t9 = <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3">{t4}{t5}{t6}{t7}{t8}</div>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default MessageList;